export type GroupBy = "agent" | "state" | "division" | "region" | "district" | "all";
export type DetailLevel = "detail" | "totals";
export type BalanceFilter = "all" | "debit" | "credit";

export const groupByLabel: Record<GroupBy, string> = {
  agent: "By Agent",
  state: "By State",
  division: "By Division",
  region: "By Region",
  district: "By District",
  all: "All — Grand Summary",
};
